import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { InterpolatedBlueprint } from '../../models/blueprint.model';
import { ReportRecord } from '../../models/report.model';
import { TemplateField } from '../../models/template.model';
import { IMAGE_FIELD_ID } from '../../shared/templates/config/common';
import { EditableFieldsService } from '../editable-fields.service';
import { onDrop } from '../summary-view/summary-view.helper';

@Component({
  selector: 'rep-comparison-view',
  templateUrl: './comparison-view.component.html',
  styleUrls: ['./comparison-view.component.scss'],
  providers: [EditableFieldsService],
  standalone: false,
})
export class ComparisonViewComponent extends AbstractDynamicReportViewComponent {
  recordNumber: number;
  allFields: TemplateField[];
  allDataFields: TemplateField[];
  @Input() recordList: any[];
  @Input() showGroup: boolean = false;
  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();

  protected prepareGroupsObjectToDisplay(interpolatedBlueprint: InterpolatedBlueprint) {
    super.prepareGroupsObjectToDisplay(interpolatedBlueprint);
    if (this.bodyGroups.length) {
      this.recordNumber = 1;
      this.allFields = [].concat(...(this.bodyGroups || []).map(group => group.fields));
      this.allDataFields = this.allFields.filter(field => field.id !== IMAGE_FIELD_ID);
    }
  }
  public onReorder(cdkDragDropEvent: CdkDragDrop<Array<{ [key: string]: any }>>) {
    onDrop(cdkDragDropEvent, this.recordList, this.reportReordered);
  }
}
